import { BevPageTypes } from '../BevPageTypes';
import { ZOOM_VALUE_DISPLAY_OFFSET } from '../constants/generalConstants';

export const getConvertedWH = (
  width: string | number,
  depth: string | number,
  isFacilityMigrated: boolean
) => ({
  width: convertWH(convertToNumber(width), isFacilityMigrated),
  height: convertWH(convertToNumber(depth), isFacilityMigrated),
});

export const convertWH = (value: any, isFacilityMigrated: boolean) =>
  round(value * 5 * (isFacilityMigrated ? 0.6 : 0.7) - 3);

export const getActualAngle = (angle: any) => {
  let actualAngle = convertToNumber(angle);
  if (actualAngle >= 360) {
    const timesToSubtract = Math.floor(actualAngle / 360);
    actualAngle -= 360 * timesToSubtract;
  } else if (angle < 0) {
    actualAngle = 360 + angle;
  }
  return round(actualAngle);
};

export const round: BevPageTypes.TRoundFn = (
  value = 0,
  precision = 2,
  returnAsString = false
) => {
  const multiplier = 10 ** precision;
  const roundedValue = (
    Math.round(convertToNumber(value) * multiplier) / multiplier || 0
  ).toFixed(precision);
  return returnAsString ? roundedValue : parseFloat(roundedValue);
};

export const convertToNumber = (inString: string | number) => Number(inString);

export const isDefaultUnit = (
  singleUnit: BevPageTypes.TUnit,
  selectedUnitId: string
) => convertToNumber(singleUnit.id) === convertToNumber(selectedUnitId);

export const zoomValueToDisplay = (zoomValue: number) =>
  `${(zoomValue * 100 - ZOOM_VALUE_DISPLAY_OFFSET).toString().split('.')[0]}%`;

export const getModalSelectedUnit = (
  unitTypesList: BevPageTypes.TUnitType[],
  selectedUnit: BevPageTypes.TUnit
) => {
  return unitTypesList.filter(
    ({ unit_type_id }) => unit_type_id === selectedUnit.unit_type.id
  );
};
